import { computed } from 'vue';
import { useSessionStore } from '@/store';

/**
 * Sold-lead gate. When a removalist has bought the lead via the Direct Quotes
 * pipeline they are in direct contact with the customer, so Muval-side
 * callback requests are no longer appropriate (CU-86d2b8xfn).
 *
 * Components should hide their callback CTA when `isSold` is true; store
 * actions short-circuit on the same flag so any unguarded caller is also
 * a no-op.
 */
export function useSoldGate() {
    // The session store's `order` is typed as a loose `{}` (declared in JS),
    // so cast to `any` to read the new `is_sold` flag exposed by the booking
    // order resource.
    const session = useSessionStore() as any;

    const isSold = computed<boolean>(() => Boolean(session?.order?.is_sold));

    return { isSold };
}
